const PageWrapper = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="bg-hero bg-cover bg-no-repeat bg-center">
            {children}
        </div >
    );
};
export default PageWrapper;
